// extracted by mini-css-extract-plugin
export var bounce = "_kx-1";
export var generatingText = "_kx-6";
export var lightning = "_kx-4";
export var popup = "_kx-5";
export var progressBar = "_kx-7";
export var progressFill = "_kx-8";
export var progressShimmer = "_kx-9";
export var progressText = "_kx-a";
export var shimmer = "_kx-3";
export var uploadIcon = "_kx-0";
export var uploadingText = "_kx-2";